import React from "react";
import { lazy } from "react";
import { Navigate } from "react-router-dom";
// import TargetInsightsReportPage from "../Pages/Reports/TargetInsightsReport/TargetInsightsPage";
import PasswordChangedFormPage from "../Pages/Settings/Users.jsx/PasswordChangedFormPage";
// import ResetPasswordPage from "../Pages/ForgotPassword/ResetPasswordPage";
import ResetPassword from "../Components/ForgetPAssword/ResetPassword";
import PublicForm from "../Components/PublicForm/PublicForm";
import MessageAutomationPage from "../Pages/MessageAutomation/MessageAutomationPage";
// import ExpiredBusinessPlanPage from "../Pages/BusinessInfoDetails/Expired Business Plans/ExpiredBusinessPlanPage";
// import CalendarPage from "../Pages/Calender/CalenderPage";
const CalendarPage = lazy(() => import("../Pages/Calender/CalendarPage"));
// const AutomationTemplatePage = lazy(() => import("../Pages/Settings/AutomationTemplates/AutomationTemplatesPage"));
// const CreateAutomationTemplatePage = lazy(() => import("../Pages/Settings/AutomationTemplates/CreateTemplatePage"));

// const CreateAutomationPage = lazy(() => import("../Pages/Settings/AutomationTemplates/CreateAutomationPage"));
const CampaignHistoryPage = lazy(() => import("../Components/Campaign/CampaignHistory/CampaignHistory"));
const CampaignHistoryDetailPage = lazy(() =>
  import("../Components/Campaign/CampaignHistory/CampaignHistoryDetailsPage")
);
const FbTokenEditPage = lazy(() => import("../Pages/FbToken/FbTokenEditPage"));

const LoginContent = lazy(() => import("../Pages/Login/LoginContent"));
const ForgotPassword = lazy(() => import("../Pages/ForgotPassword/ForgotPassword"));

const ActvitiesPage = lazy(() => import("../Pages/Activities/ActvitiesPage"));
const AssignedTargetsPage = lazy(() => import("../Pages/AssignedTargets/AssignedTargetsPage"));
const UpdateProfilePage = lazy(() => import("../Pages/Profile/UpdateProfilePage"));
const ComposePage = lazy(() => import("../Pages/Email/ComposePage"));
const InboxPage = lazy(() => import("../Pages/Email/InboxPage"));
const DraftPage = lazy(() => import("../Pages/Email/DraftPage"));
const OutBoxPage = lazy(() => import("../Pages/Email/OutBoxPage"));
const SentPage = lazy(() => import("../Pages/Email/SentPage"));
const TrashPage = lazy(() => import("../Pages/Email/TrashPage"));
const MeetingsPage = lazy(() => import("../Pages/Meetings/MeetingsPage"));
const MeetingsCreatePage = lazy(() => import("../Pages/Meetings/MeetingsCreatePage"));
const MeetingsCreateIdPage = lazy(() => import("../Pages/Meetings/MeetingsCreateIdPage"));
const EditActivitiesPage = lazy(() => import("../Pages/Activities/EditActivitiesPage"));
const ProductsPage = lazy(() => import("../Pages/Products/ProductsPage"));
const CreateProductPage = lazy(() => import("../Pages/Products/CreateProductPage"));
const ServicePage = lazy(() => import("../Pages/Service/ServicePage"));
const CreateServicePage = lazy(() => import("../Pages/Service/CreateServicePage"));
const TransferLeadsPage = lazy(() => import("../Pages/TansferLeads/TransferLeadsPage"));
const LeadsPage = lazy(() => import("../Pages/Leads/LeadsPage"));
const LeadViewPage = lazy(() => import("../Pages/Leads/LeadViewPage"));
const CreateLeadsPage = lazy(() => import("../Pages/Leads/CreateLeadsPage"));
const RecycleLeadsPage = lazy(() => import("../Pages/RecycleLeads/RecycleLeadsPage"));
const QuotesPage = lazy(() => import("../Pages/Quotes/QuotesPage"));
const CreateQuotesPage = lazy(() => import("../Pages/Quotes/CreateQuotesPage"));
const QuotePdfPreviewPage = lazy(() => import("../Pages/Quotes/QuotePdfPreviewPage"));
const PersonsPage = lazy(() => import("../Pages/Contacts/Persons/PersonsPage"));
const PersonsProspectPage = lazy(() => import("../Pages/Contacts/Persons/PersonsProspectPage"));
const OrganizationsPage = lazy(() => import("../Pages/Contacts/Organizations/OrganizationsPage"));
const PersonsAffiliatePage = lazy(() => import("../Pages/Contacts/Persons/PersonsAffiliatePage"));
const CreateOrganizationPage = lazy(() => import("../Pages/Contacts/Organizations/CreateOrganizationPage"));
const CreatePersonFormCustomerPage = lazy(() => import("../Pages/Contacts/Persons/CreatePersonFormCustomerPage"));
const CreatePersonFormProspectPage = lazy(() => import("../Pages/Contacts/Persons/CreatePersonFormProspectPage"));
const CreatePersonFormAffiliatePage = lazy(() => import("../Pages/Contacts/Persons/CreatePersonFormAffiliatePage"));
const CampaignsPage = lazy(() => import("../Components/Campaign/Campaigns/CampaignsPage"));
const CreateCampaignsPage = lazy(() => import("../Components/Campaign/Campaigns/CreateCampaignsPage"));
const TemplatePage = lazy(() => import("../Components/Campaign/Templates/TemplatePage"));
const CreateTemplatePage = lazy(() => import("../Components/Campaign/Templates/CreateTemplatePage"));
const CampaignGroupsPage = lazy(() => import("../Components/Campaign/CampaignGroups/CampaignGroupsPage"));
const CreateCampaignGroupsPage = lazy(() => import("../Components/Campaign/CampaignGroups/CreateCampaignGroupsPage"));
// const UserPerformanceReportPage = lazy(() =>
//   import("../Pages/Reports/UserPerformanceReport/UserPerformanceReportPage")
// );
// const DailyActivitiesReportPage = lazy(() => import("../Pages/Reports/DailyActivities/DailyActivitiesReportPage"));
// const UserLeadsReportPage = lazy(() => import("../Pages/Reports/UserLeadsReport/UserLeadsReportPage"));
// const UserActivitiesReportPage = lazy(() => import("../Pages/Reports/UserActivitiesReport/UserActivitiesReportPage"));
// const UserWonLeadsReportPage = lazy(() => import("../Pages/Reports/UserWonLeadsReport/UserWonLeadsReportPage"));
// const UserTargetReportPage = lazy(() => import("../Pages/Reports/UserTargetReport/UserTargetReportPage"));
// const GroupPerformanceReportPage = lazy(() =>
//   import("../Pages/Reports/GroupPerformanceReport/GroupPerformanceReportPage")
// );
// const ProfitReportPage = lazy(() => import("../Pages/Reports/ProfitReport/ProfitReportPage"));
// const SaleReportPage = lazy(() => import("../Pages/Reports/SalesReport/SaleReportPage"));
const UserCommissionReportPage = lazy(() => import("../Pages/Reports/UserCommissionReport/UserCommissionReportPage"));
const CommissionSummaryPage = lazy(() => import("../Pages/Reports/CommissionSummary/CommissionSummaryPage"));
const ProjectWiseCommissionPage = lazy(() =>
  import("../Pages/Reports/Project-Wise-Commission/ProjectWiseCommissionPage")
);
const AffiliatePerformancePage = lazy(() => import("../Pages/Reports/AffiliatePerformance/AffiliatePerformancePage"));
const MonthlyYearlyCommissionPage = lazy(() =>
  import("../Pages/Reports/Monthly-YearlyCommission/MonthlyYearlyCommissionPage")
);
const GenerateCommissionsPage = lazy(() => import("../Pages/GenerateCommissions/GenerateCommissionsPage"));
const PayCommissionsPage = lazy(() => import("../Pages/PayCommission/PayCommissionsPage"));
const GenerateCommissionsFormPage = lazy(() => import("../Pages/GenerateCommissions/GenerateCommissionsFormPage"));
const PayCommissionFormPage = lazy(() => import("../Pages/PayCommission/PayCommissionFormPage"));
const ReportErrorsPage = lazy(() => import("../Pages/ReportErrorsPage"));
const SettingsPage = lazy(() => import("../Pages/Settings/SettingsPage"));
const GroupsPage = lazy(() => import("../Components/Settings/User/Groups/GroupsPage"));
const CreateGroupPage = lazy(() => import("../Components/Settings/User/Groups/CreateGroupPage"));
const SupportPage = lazy(() => import("../Components/Settings/OtherSettings/SupportPage"));
const FbTokenTablePage = lazy(() => import("../Pages/FbToken/FbTokenTablePage"));
const FbTokenPage = lazy(() => import("../Pages/FbToken/FbTokenPage"));
const WATokenTablePage = lazy(() => import("../Pages/WAToken/WATokenTablePage"));
// const WhatsAppToken = lazy(() => import("../Pages/WAToken/WAToken"));
const BusinessInfoDetailsPage = lazy(() => import("../Pages/BusinessInfoDetails/BusinessInfoDetailsPage"));
const CommissionHeadsPage = lazy(() => import("../Pages/CommissionSettings/CommissionHeadsPage"));
const CommissionTemplatesPage = lazy(() => import("../Pages/CommissionSettings/CommissionTemplatesPage"));
// const CreateHeadsPage = lazy(() => import("../Pages/CommissionSettings/CreateHeadsPage"));
const CreateTemplatesPage = lazy(() => import("../Pages/CommissionSettings/CreateTemplatesPage"));
const PublicLeadsPage = lazy(() => import("../Pages/PublicLeads/PublicLeadsPage"));
const RolesPage = lazy(() => import("../Pages/Settings/OtherSettings/RolesPage"));
const CreateRolePage = lazy(() => import("../Pages/Settings/OtherSettings/CreateRolePage"));
const UsersPage = lazy(() => import("../Pages/Settings/Users.jsx/UsersPage"));
const CreateUsersPage = lazy(() => import("../Pages/Settings/Users.jsx/CreateUsersPage"));
const UsersChatsPage = lazy(() => import("../Pages/Settings/Users.jsx/UsersChatsPage"));
const LeadPage = lazy(() => import("../Pages/Settings/Lead/LeadPage"));
const PiplinesPage = lazy(() => import("../Pages/Settings/Lead/PiplinesPage"));
// const CreatePiplinesPage = lazy(() => import("../Pages/Settings/Lead/CreatePiplinesPage"));
const SourcesPage = lazy(() => import("../Pages/Settings/Lead/SourcesPage"));
// const CreateSourcesPage = lazy(() => import("../Pages/Settings/Lead/CreateSourcesPage"));
const TypesPage = lazy(() => import("../Pages/Settings/Lead/Types/TypesPage"));
// const CreateTypesPage = lazy(() => import("../Pages/Settings/Lead/Types/CreateTypesPage"));
const ActivityTypesPage = lazy(() => import("../Pages/Settings/Lead/ActivityTypesPage"));
const TagsPage = lazy(() => import("../Pages/Settings/OtherSettings/Tags/TagsPage"));
// const CreateTagsPage = lazy(() => import("../Pages/Settings/OtherSettings/Tags/CreateTagsPage"));
const ChangeRequestPage = lazy(() => import("../Pages/Settings/OtherSettings/ChangeRequest/ChangeRequestPage"));
const CreateChangeRequestPage = lazy(() =>
  import("../Pages/Settings/OtherSettings/ChangeRequest/CreateChangeRequestPage")
);
const DescriptionsPage = lazy(() => import("../Pages/Settings/Lead/Descriptions/DescriptionsPage"));
// const DescriptionCreateFormPage = lazy(() => import("../Pages/Settings/Lead/Descriptions/DescriptionCreateFormPage"));
const FacebookPagePage = lazy(() => import("../Pages/FacebookPage/FacebookPagePage"));
const WhatsAppPage = lazy(() => import("../Pages/WhatsApp/WhatsAppPage"));
const InstagramPagePage = lazy(() => import("../Pages/InstagramPage/InstagramPagePage"));

const ProjectPage = lazy(() => import("../Pages/Settings/Inventory/Project/ProjectPage"));
const CreateProjectPage = lazy(() => import("../Pages/Settings/Inventory/Project/CreateProjectPage"));
const InventoryOverviewPage = lazy(() =>
  import("../Pages/Inventory/Overview/InventoryOverviewPage")
);
const UnitPage = lazy(() => import("../Pages/Inventory/Unit/UnitPage"));
const BookedUnitsPage = lazy(() => import("../Pages/Inventory/BookedUnit/BookedUnitsPage"));
const CreateUnitPage = lazy(() => import("../Pages/Inventory/Unit/CreateUnitPage"));
const SectionPage = lazy(() => import("../Pages/Settings/Inventory/Section/SectionPage"));
const CreateSectionPage = lazy(() => import("../Pages/Settings/Inventory/Section/CreateSectionPage"));
const CategoryPage = lazy(() => import("../Pages/Settings/Inventory/Category/CategoryPage"));
// const CategoryCreateUpdateScreenPage = lazy(() =>
//   import("../Pages/Settings/Inventory/Category/CategoryCreateUpdateScreenPage")
// );
const TargetPage = lazy(() => import("../Pages/Targets/TargetPage"));
const CreateTargetPage = lazy(() => import("../Pages/Targets/CreateTargetPage"));
// const NewDashboardPage = lazy(() => import("../Pages/Dashboard2/NewDashboardPage"));
const BusinessTablePage = lazy(() => import("../Pages/BusinessInfoDetails/BusinessTablePage"));
const EditBusinessInfoPage = lazy(() => import("../Pages/BusinessInfoDetails/EditBusinessInfoPage"));
const SubscriptionTablePage = lazy(() =>
  import("../Pages/BusinessInfoDetails/SubscriptionTable/SubscriptionTablePage")
);
const SubscriptionFormPage = lazy(() => import("../Pages/BusinessInfoDetails/SubscriptionTable/SubscriptionFormPage"));
const ScreensPage = lazy(() => import("../Pages/Screens/ScreensPage"));
const UserOverviewPage = lazy(() => import("../Pages/Settings/Users.jsx/UserOverviewPage"));
const TransactionsTablePage = lazy(() => import("../Pages/BusinessInfoDetails/Transactions/TransactionsTablePage"));
const TransactionFormPage = lazy(() => import("../Pages/BusinessInfoDetails/Transactions/TransactionFormPage"));
const ConfigSettingTablePage = lazy(() => import("../Pages/BusinessInfoDetails/ConfigSetting/ConfigSettingTablePage"));
const ConfigSettingFormPage = lazy(() => import("../Pages/BusinessInfoDetails/ConfigSetting/ConfigSettingFormPage"));
const ModuleTablePage = lazy(() => import("../Pages/BusinessInfoDetails/Module/ModuleTablePage"));
const ModuleFormPage = lazy(() => import("../Pages/BusinessInfoDetails/Module/ModuleFormPage"));
const BusinessInfoDetailsSuperAdminPage = lazy(() =>
  import("../Pages/BusinessInfoDetails/BusinessInfoDetailsSuperAdminPage")
);
const ExpiredBusinessPlanPage = lazy(() =>
  import("../Pages/BusinessInfoDetails/Expired Business Plans/ExpiredBusinessPlanPage")
);
const SalesPipelineReportPage = lazy(() =>
  import("../Pages/Reports/SalesPipelineReport/SalesPipelineReportPage")
);
const AgentTeamProductivityPage = lazy(() =>
  import("../Pages/Reports/AgentTeamProductivity/AgentTeamProductivityPage")
);
const TargetVsAchievementPage = lazy(() =>
  import("../Pages/Reports/TargetVsAchievement/TargetVsAchievementPage")
);
const DealLossReasonAnalysisPage = lazy(() =>
  import("../Pages/Reports/DealLossReasonAnalysis/DealLossReasonAnalysisPage")
);
const PipelineVelocityReportPage = lazy(() =>
  import("../Pages/Reports/PipelineVelocityReport/PipelineVelocityReportPage")
);
const LeadTransferAuditReportPage = lazy(() =>
  import("../Pages/Reports/LeadTransferAuditReport/LeadTransferAuditReportPage")
);
const CommissionAndFinancialLedgerPage = lazy(() =>
  import("../Pages/Reports/CommissionAndFinancialLedger/CommissionAndFinancialLedgerPage")
);
const InventoryStockAbsorptionPage = lazy(() =>
  import("../Pages/Reports/InventoryStockAbsorption/InventoryStockAbsorptionPage")
);
const CommissionDashboardPage = lazy(() =>
  import("../Pages/Reports/CommissionDashboard/CommissionDashboardPage")
);

const AdminDashboardPage = lazy(() => import("../Pages/RolesDashboard/AdminDashboard/AdminDashboardPage"));
const BdaDashboardPage = lazy(() => import("../Pages/RolesDashboard/BdaDashboard/BdaDashboardPage"));
const BdmDashboardPage = lazy(() => import("../Pages/RolesDashboard/BdmDashboard/BdmDashboardPage"));

export const AdminRoutes = [
  {
    path: "/",
    component: <LoginContent />,
  },
  {
    path: "/dashboard",
    component: <AdminDashboardPage />,
    // component: <NewDashboardPage />,
    joyrideSteps: [
      {
        target: ".to",
        content: "Welcome!! Please spare a minute to learn about our page",
        // Add this
        disableBeacon: true,
      },
      {
        target: ".get",
        content: "You can log in here",
      },
    ],
    roleName: "Dashboard",
  },
  {
    path: "/dashboard/admin",
    component: <AdminDashboardPage />,

    roleName: "Dashboard",
  },
  {
    path: "/dashboard/bda",
    component: <BdaDashboardPage />,

    roleName: "Dashboard",
  },
  {
    path: "/dashboard/bdm",
    component: <BdmDashboardPage />,

    roleName: "Dashboard",
  },
  {
    path: "/profile",
    component: <UpdateProfilePage />,
    roleName: [
      "CRM-Profile",
    ],
  },
  {
    path: "/profile/business",
    component: <UpdateProfilePage defaultTab="business" />,
    roleName: [
      "CRM-Profile_Business",
    ],
  },
  {
    path: "/settings/profile/business",
    component: <UpdateProfilePage defaultTab="business" />,
    roleName: [
      "CRM-Profile",
      "CRM-Profile_Business",
      "CRM-Business_View",
      "CRM-Business_Edit",
    ],
  },
  {
    path: "/forgotpassword",
    component: <ForgotPassword />,
  },
  {
    path: "/reset/password",
    component: <ResetPassword />,
  },
  {
    path: "/email/compose",
    component: <ComposePage />,
  },
  {
    path: "/email/inbox",
    component: <InboxPage />,
  },
  {
    path: "/email/draft",
    component: <DraftPage />,
  },
  {
    path: "/email/outbox",
    component: <OutBoxPage />,
  },
  {
    path: "/email/sent",
    component: <SentPage />,
  },
  {
    path: "/email/trash",
    component: <TrashPage />,
  },
  {
    path: "/meetings",
    RoleName: "Internal Meeting",
    component: <MeetingsPage />,
    // component: <AdminDashboardPage />,
  },

  {
    path: "/meetings/create",
    component: <MeetingsCreatePage />,
  },
  {
    path: "/meetings/create/:id",
    component: <MeetingsCreateIdPage />,
  },
  {
    path: "/activities",
    component: <ActvitiesPage />,
    // component: <BdaDashboardPage />,
    roleName: "Activities",
  },
  {
    path: "/edit/activities",
    component: <EditActivitiesPage />,
    roleName: "Activities_Create",
  },
  {
    path: "/products",
    component: <ProductsPage />,
  },
  {
    path: "/products/create",
    component: <CreateProductPage />,
  },
  {
    path: "/service",
    component: <ServicePage />,
  },
  {
    path: "/service/create",
    component: <CreateServicePage />,
  },
  {
    path: "/TransferLeads",
    component: <TransferLeadsPage />,
    roleName: "Leads_Transfer",
  },
  {
    path: "/leads",
    component: <LeadsPage />,
    joyrideSteps: [
      {
        target: ".leadsIntro",
        content: "Welcome!! Please spare a minute to learn about our page",
        // Add this
        disableBeacon: true,
      },
    ],
    roleName: "Leads",
  },
  {
    path: "/leads/view",
    component: <LeadViewPage />,
    roleName: "Leads_View",
  },
  {
    path: "/leads/create",
    component: <CreateLeadsPage />,
    roleName: "Leads_Create",
  },

  {
    path: "/recycle-leads",
    component: <RecycleLeadsPage />,
    roleName: "Leads_Recycle",
    joyrideSteps: [
      {
        target: ".leadsRecycleIntro",
        content: "Welcome!! Please spare a minute to learn about our page",
        // Add this
        disableBeacon: true,
      },
    ],
  },
  {
    path: "/quotes",
    component: <QuotesPage />,
  },
  {
    path: "/quotes/create",
    component: <CreateQuotesPage />,
  },
  {
    path: "/quotes/pdf-preview",
    component: <QuotePdfPreviewPage />,
  },
  {
    path: "/contacts/persons",
    component: <PersonsPage />,
    roleName: "Persons",
  },
  {
    path: "/contacts/prospects",
    component: <PersonsProspectPage />,
    roleName: "CRM-Contacts_Prospect",
  },
  {
    path: "/contacts/organizations",
    component: <OrganizationsPage />,
    roleName: "Organizations",
  },
  {
    path: "/contacts/affiliate",
    component: <PersonsAffiliatePage />,
    roleName: "Contacts_Affiliates",
  },
  {
    path: "/contacts/organizations/create",
    component: <CreateOrganizationPage />,
    roleName: "Organizations_Create",
  },
  {
    path: "/contacts/persons/createPerson",
    component: <CreatePersonFormCustomerPage />,
    roleName: "Persons_Create",
  },
  {
    path: "/contacts/prospects/createProspect",
    component: <CreatePersonFormProspectPage />,
    roleName: "CRM-Prospect_Create",
  },
  {
    path: "/contacts/affiliate/createAffiliate",
    component: <CreatePersonFormAffiliatePage />,
    roleName: "Affiliates_Create",
  },
  {
    path: "/campaigns/campaign",
    component: <CampaignsPage />,
    roleName: "Campaign_Campaigns",
  },
  {
    path: "/campaigns/campaign/create",
    component: <CreateCampaignsPage />,
    roleName: "Campaigns_Create",
  },
  {
    path: "/campaigns/templates",
    component: <TemplatePage />,
    roleName: "Campaign_Templates",
  },
  {
    path: "/campaigns/templates/create",
    component: <CreateTemplatePage />,
    roleName: "Templates_Create",
  },
  {
    path: "/campaigns/groups",
    component: <CampaignGroupsPage />,
    roleName: "Campaign_Campaign_Groups",
  },
  {
    path: "/campaigns/groups/create",
    component: <CreateCampaignGroupsPage />,
    roleName: "Campaign_Groups_Create",
  },
  {
    path: "/campaigns/history",
    component: <CampaignHistoryPage />,
    roleName: "Campaign_History",
  },
  {
    path: "/campaigns/history/details",
    component: <CampaignHistoryDetailPage />,
    roleName: "History_Details",
  },
  // {
  //   path: "/reports/user-performance",
  //   component: <UserPerformanceReportPage />,
  //   roleName: "Reports_User Performance",
  // },
  // {
  //   path: "/reports/daily-activities",
  //   component: <DailyActivitiesReportPage />,
  //   roleName: "Reports_User Performance",
  // },
  // {
  //   path: "/reports/user-leads",
  //   component: <UserLeadsReportPage />,
  //   roleName: "Reports_User Leads",
  // },
  // {
  //   path: "/reports/user-activity",
  //   component: <UserActivitiesReportPage />,
  //   roleName: "Reports_User Activities",
  // },
  // {
  //   path: "/reports/user-won-leads",
  //   component: <UserWonLeadsReportPage />,
  //   roleName: "Reports_User Won Leads",
  // },
  // {
  //   path: "/reports/target-insights",
  //   component: <TargetInsightsReportPage />,
  //   roleName: "Reports_User Won Leads",
  // },
  // {
  //   path: "/reports/user-targets",
  //   component: <UserTargetReportPage />,
  //   roleName: "Reports_User Targets",
  // },
  // {
  //   path: "/reports/group-performance",
  //   component: <GroupPerformanceReportPage />,
  //   roleName: "Reports_Group Performance",
  // },
  // {
  //   path: "/reports/profit",
  //   component: <ProfitReportPage />,
  // },
  // {
  //   path: "/reports/SaleReport",
  //   component: <SaleReportPage />,
  //   roleName: "Reports_Sales Report",
  // },
  {
    path: "/reports/sales-pipeline-performance",
    component: <SalesPipelineReportPage />,
    roleName: "CRM-Reports_Sales Performance Report",
  },
  {
    path: "/reports/agent-team-productivity-scorecard",
    component: <AgentTeamProductivityPage />,
    roleName: "CRM-Reports_Agent Team Productivity",
  },
  {
    path: "/reports/target-vs-achievement-scorecard",
    component: <TargetVsAchievementPage />,
    roleName: "CRM-Reports_Target Vs Achievement",
  },
  {
    path: "/reports/deal-loss-reason-analysis",
    component: <DealLossReasonAnalysisPage />,
    roleName: "CRM-Reports_Deal Loss Reason Analysis",
  },
  {
    path: "/reports/pipeline-velocity",
    component: <PipelineVelocityReportPage />,
    roleName: "CRM-Reports_Pipeline Velocity Sales Cycle",
  },
  {
    path: "/reports/lead-transfer-audit",
    component: <LeadTransferAuditReportPage />,
    roleName: "CRM-Reports_Lead Transfer Decay Audit",
  },
  {
    path: "/reports/commission-financial-ledger",
    component: <CommissionAndFinancialLedgerPage />,
    roleName: "CRM-Reports_Commission Financial Ledger",
  },
  {
    path: "/reports/inventory-stock-absorption",
    component: <InventoryStockAbsorptionPage />,
    roleName: "CRM-Reports_Inventory Stock Absorption",
  },
  {
    path: "/reports/commission-dashboard",
    component: <CommissionDashboardPage />,
    roleName: "CRM-Reports_Commission Dashboard",
  },
  {
    path: "/commission-reports/user-commission",
    component: <UserCommissionReportPage />,
    roleName: "Commission Reports_User Commission",
  },
  {
    path: "/commission-reports/CommissionSummary",
    component: <CommissionSummaryPage />,
    roleName: "Commission Reports_Commission Summary",
  },
  {
    path: "/commission-reports/project-commission",
    component: <ProjectWiseCommissionPage />,
    roleName: "Commission Reports_Project Commission",
  },
  {
    path: "/commission-reports/AffiliatePerformance",
    component: <AffiliatePerformancePage />,
    roleName: "Commission Reports_Affiliate Performance",
  },
  {
    path: "/commission-reports/commission-trends",
    component: <MonthlyYearlyCommissionPage />,
    roleName: "Commission Reports_Commission Trends",
  },
  //////
  {
    path: "/commission/generate_commission",
    component: <GenerateCommissionsPage />,
    RoleName: "Commission",
  },
  {
    path: "/commission/pay_commission",
    component: <PayCommissionsPage />,
    RoleName: "Commission",
  },
  {
    path: "/commission/generate_commission/create",
    component: <GenerateCommissionsFormPage />,
    RoleName: "Commission_Create",
  },
  {
    path: "/commission/pay_commission/create",
    component: <PayCommissionFormPage />,
    RoleName: "Commission_Create",
  },
  {
    path: "/report-errors",
    component: <ReportErrorsPage />,
  },
  {
    path: "/settings",
    component: <SettingsPage />,
    roleName: "Settings",
  },
  {
    path: "/settings/groups",
    component: <GroupsPage />,
    roleName: "Groups",
  },
  {
    path: "/create/group",
    component: <CreateGroupPage />,
    roleName: "Groups_Create",
  },
  {
    path: "/settings/support",
    component: <SupportPage />,
    roleName: "Support_View",
  },
  {
    path: "/settings/calender",
    component: <CalendarPage />,
    // roleName: "Support_View",
  },
  {
    path: "/settings/fbpagetoken",
    component: <FbTokenTablePage />,
    roleName: "CRM-Social_Integration_Facebook Page",
  },
  {
    path: "/create/fbpagetoken",
    component: <FbTokenPage />,
    roleName: "CRM-Facebook Page_Create",
  },
  {
    path: "/edit/fbpagetoken",
    component: <FbTokenEditPage />,
    roleName: "CRM-Facebook Page_Edit",
  },
  {
    path: "/settings/whatsappPageToken",
    component: <WATokenTablePage />,
    roleName: "CRM-Social_Integration_WhatsApp Account",
  },
  // {
  //   path: "/create/whatsappPageToken",
  //   component: <WhatsAppToken />,
  //   roleName: "CRM-WhatsApp Account_Create",
  // },
  {
    path: "/settings/business",
    component: <BusinessInfoDetailsPage />,
    roleName: "Other Settings_Business",
  },
  {
    path: "/settings/commission_heads",
    component: <CommissionHeadsPage />,
    roleName: "Commission",
  },
  {
    path: "/settings/commission_templates",
    component: <CommissionTemplatesPage />,
    roleName: "Commission",
  },
  // {
  //   path: "/settings/create/commission_heads",
  //   component: <CreateHeadsPage />,
  //   roleName: "Commission_Create",
  // },
  {
    path: "/settings/create/commission_template",
    component: <CreateTemplatesPage />,
    roleName: "Commission_Create",
  },
  {
    path: "/publicleads",
    component: <PublicLeadsPage />,
    roleName: "Leads_Public Leads",
  },
  // {
  //   path: "/settings/fbpagetoken",
  //   component: (
  //     <UseContainer
  //       activePage={<FbToken />}
  //       disableTitleBar={true}
  //       headerTitle={"Facebook Token"}
  //       buttons={[]}
  //     />
  //   ),
  // },
  {
    path: "/settings/roles",
    component: <RolesPage />,
    roleName: "Roles",
  },
  {
    path: "/create/roles",
    component: <CreateRolePage />,
    roleName: "Roles_Create",
  },
  {
    path: "/settings/users",
    component: <UsersPage />,
    roleName: "Users",
  },
  {
    path: "/create/users",
    component: <CreateUsersPage />,
    roleName: "Users_Create",
  },
  {
    path: "/password/change",
    component: <PasswordChangedFormPage />,
  },
  {
    path: "/settings/users-chats",
    component: <UsersChatsPage />,
    roleName: "Chats",
  },
  {
    path: "/settings/lead",
    component: <LeadPage />,
    roleName: "Lead",
  },
  {
    path: "/settings/piplines",
    component: <PiplinesPage />,
    roleName: "Pipelines",
  },
  // {
  //   path: "/settings/piplines/create",
  //   component: <CreatePiplinesPage />,
  //   roleName: "Pipelines_Create",
  // },
  {
    path: "/settings/sources",
    component: <SourcesPage />,
    roleName: "Sources",
  },
  // {
  //   path: "/settings/sources/create",
  //   component: <CreateSourcesPage />,
  //   roleName: "Sources_Create",
  // },
  {
    path: "/settings/Types",
    component: <TypesPage />,
    roleName: "Types",
  },
  // {
  //   path: "/settings/types/create",
  //   component: <CreateTypesPage />,
  //   roleName: "Types_Create",
  // },
  {
    path: "/settings/activity-types",
    component: <ActivityTypesPage />,
    roleName: "Types",
  },
  {
    path: "/settings/Tags",
    component: <TagsPage />,
    roleName: "Tags",
  },
  // {
  //   path: "/settings/tags/create",
  //   component: <CreateTagsPage />,
  //   roleName: "Tags_Create",
  // },
  {
    path: "/settings/change-request",
    component: <ChangeRequestPage />,
  },
  {
    path: "/settings/change-request/create",
    component: <CreateChangeRequestPage />,
  },
  {
    path: "/settings/descriptions",
    component: <DescriptionsPage />,
    roleName: "Lead_Descriptions",
  },
  // {
  //   path: "/settings/descriptions/create",
  //   component: <DescriptionCreateFormPage />,
  //   roleName: "Descriptions_Create",
  // },
  {
    path: "/chats/facebookpage",
    component: <FacebookPagePage />,
    roleName: "Socials_Facebook",
  },
  {
    path: "/chats/instagrampage",
    component: <InstagramPagePage />,
    roleName: "Socials_Instagram",
  },
  {
    path: "/chats/whatsApp",
    component: <WhatsAppPage />,
    roleName: "Socials_Whatsapp",
  },
  {
    path: "/settings/inventory/project",
    component: <ProjectPage />,
    roleName: "Inventory Settings_Projects",
  },
  {
    path: "/settings/inventory/project/create",
    component: <CreateProjectPage />,
    roleName: "Projects_Create",
  },
  {
    path: "/inventory/overview",
    component: <Navigate to="/inventory/insights/overview" replace />,
    roleName: "Inventory_Unit",
  },
  {
    path: "/inventory/insights/overview",
    component: <InventoryOverviewPage />,
    roleName: "Inventory_Unit",
  },
  {
    path: "/inventory/insights/aging",
    component: <InventoryOverviewPage />,
    roleName: "Inventory_Unit",
  },
  {
    path: "/inventory/insights/performance",
    component: <InventoryOverviewPage />,
    roleName: "Inventory_Unit",
  },
  {
    path: "/inventory/unit",
    component: <UnitPage />,
    roleName: "Inventory_Unit",
  },
  {
    path: "/inventory/booked-unit",
    component: <BookedUnitsPage />,
    roleName: "Inventory_Booked Unit",
  },
  {
    path: "/inventory/unit/create",
    component: <CreateUnitPage />,
    roleName: "Unit_Create",
  },
  {
    path: "/settings/inventory/section",
    component: <SectionPage />,
    roleName: "Inventory Settings_Sections",
  },
  {
    path: "/settings/inventory/section/create",
    component: <CreateSectionPage />,
    roleName: "Sections_Create",
  },
  {
    path: "/settings/inventory/category",
    component: <CategoryPage />,
    roleName: "Inventory Settings_Category",
  },
  // {
  //   path: "/settings/inventory/category/create",
  //   component: <CategoryCreateUpdateScreenPage />,
  //   roleName: "Category_Create",
  // },
  {
    path: "/target",
    component: <TargetPage />,
    roleName: "Target_Targets",
  },
  {
    path: "/target/create",
    component: <CreateTargetPage />,
    roleName: "Targets_Create",
  },
  {
    path: "/assigned-target",
    component: <AssignedTargetsPage />,
    roleName: "Target_Assign Targets",
  },
  {
    path: "/public-form",
    component: <PublicForm />,
    public: true,
  },
  {
    path: "/settings/message-automation",
    component: <MessageAutomationPage />,
    roleName: "CRM-Social_Integration_Message Automation",
  },
  // {
  //   path: "/settings/automation/templates",
  //   component: <AutomationTemplatePage />,
  //   roleName: "CRM-Automation_Auto-Templates",
  // },
  // {
  //   path: "/settings/automation/templates/create",
  //   component: <CreateAutomationTemplatePage />,
  //   roleName: "CRM-Auto-Templates_Create",
  // },
  // {
  //   path: "/settings/automation/create",
  //   component: <CreateAutomationPage />,
  //   roleName: "CRM-Automation_Auto-Templates",
  // }
];

export const NonAdminRoutes = [
  {
    path: "/",
    component: <LoginContent />,
  },
  {
    path: "/dashboard",
    // component: <NewDashboardPage />,
    component: <AdminDashboardPage />,
    joyrideSteps: [
      {
        target: ".to",
        content: "Welcome!! Please spare a minute to learn about our page",
        // Add this
        disableBeacon: true,
      },
      {
        target: ".get",
        content: "You can log in here",
      },
    ],
    roleName: "Dashboard",
  },
  {
    path: "/profile",
    component: <UpdateProfilePage />,
    roleName: [
      "CRM-Profile",
    ],
  },
  {
    path: "/profile/business",
    component: <UpdateProfilePage defaultTab="business" />,
    roleName: [
      "CRM-Profile_Business",
    ],
  },
  {
    path: "/settings/profile/business",
    component: <UpdateProfilePage defaultTab="business" />,
    roleName: [
      "CRM-Profile_Business",
    ],
  },
  {
    path: "/forgotpassword",
    component: <ForgotPassword />,
  },
  {
    path: "/reset/password",
    component: <ResetPassword />,
  },
  {
    path: "/email/compose",
    component: <ComposePage />,
  },
  {
    path: "/email/inbox",
    component: <InboxPage />,
  },
  {
    path: "/email/draft",
    component: <DraftPage />,
  },
  {
    path: "/email/outbox",
    component: <OutBoxPage />,
  },
  {
    path: "/email/sent",
    component: <SentPage />,
  },
  {
    path: "/email/trash",
    component: <TrashPage />,
  },
  {
    path: "/meetings",
    component: <MeetingsPage />,
  },

  {
    path: "/meetings/create",
    component: <MeetingsCreatePage />,
  },
  {
    path: "/meetings/create/:id",
    component: <MeetingsCreateIdPage />,
  },
  {
    path: "/activities",
    component: <ActvitiesPage />,
    roleName: "Activities",
  },
  {
    path: "/edit/activities",
    component: <EditActivitiesPage />,
    roleName: "Activities_Create",
  },
  {
    path: "/products",
    component: <ProductsPage />,
  },
  {
    path: "/products/create",
    component: <CreateProductPage />,
  },
  {
    path: "/service",
    component: <ServicePage />,
  },
  {
    path: "/service/create",
    component: <CreateServicePage />,
  },
  {
    path: "/TransferLeads",
    component: <TransferLeadsPage />,
    roleName: "Leads_Transfer",
  },
  {
    path: "/leads",
    component: <LeadsPage />,
    joyrideSteps: [
      {
        target: ".leadsIntro",
        content: "Welcome!! Please spare a minute to learn about our page",
        // Add this
        disableBeacon: true,
      },
    ],
    roleName: "Leads",
  },
  {
    path: "/leads/view",
    component: <LeadViewPage />,
    roleName: "Leads_View",
  },
  {
    path: "/leads/create",
    component: <CreateLeadsPage />,
    roleName: "Leads_Create",
  },

  {
    path: "/recycle-leads",
    component: <RecycleLeadsPage />,
    roleName: "Leads_Recycle",
    joyrideSteps: [
      {
        target: ".leadsRecycleIntro",
        content: "Welcome!! Please spare a minute to learn about our page",
        // Add this
        disableBeacon: true,
      },
    ],
  },
  {
    path: "/quotes",
    component: <QuotesPage />,
  },
  {
    path: "/quotes/create",
    component: <CreateQuotesPage />,
  },
  {
    path: "/contacts/persons",
    component: <PersonsPage />,
    roleName: "Persons",
  },
  {
    path: "/contacts/prospects",
    component: <PersonsProspectPage />,
    roleName: "Persons",
  },
  {
    path: "/contacts/organizations",
    component: <OrganizationsPage />,
    roleName: "Organizations",
  },
  {
    path: "/contacts/affiliate",
    component: <PersonsAffiliatePage />,
    roleName: "Contacts_Affiliates",
  },
  {
    path: "/contacts/organizations/create",
    component: <CreateOrganizationPage />,
    roleName: "Organizations_Create",
  },
  {
    path: "/contacts/persons/createPerson",
    component: <CreatePersonFormCustomerPage />,
    roleName: "Persons_Create",
  },
  {
    path: "/contacts/prospects/createProspect",
    component: <CreatePersonFormProspectPage />,
    roleName: "CRM-Prospect_Create",
  },
  {
    path: "/contacts/affiliate/createAffiliate",
    component: <CreatePersonFormAffiliatePage />,
    roleName: "Affiliates_Create",
  },
  {
    path: "/campaigns/campaign",
    component: <CampaignsPage />,
    roleName: "Campaign_Campaigns",
  },
  {
    path: "/campaigns/campaign/create",
    component: <CreateCampaignsPage />,
    roleName: "Campaigns_Create",
  },
  {
    path: "/campaigns/templates",
    component: <TemplatePage />,
    roleName: "Campaign_Templates",
  },
  {
    path: "/campaigns/templates/create",
    component: <CreateTemplatePage />,
    roleName: "Templates_Create",
  },
  {
    path: "/campaigns/groups",
    component: <CampaignGroupsPage />,
    roleName: "Campaign_Campaign_Groups",
  },
  {
    path: "/campaigns/groups/create",
    component: <CreateCampaignGroupsPage />,
    roleName: "Campaign_Groups_Create",
  },
  {
    path: "/campaigns/history",
    component: <CampaignHistoryPage />,
    roleName: "Campaign_History",
  },
  {
    path: "/campaigns/history/details",
    component: <CampaignHistoryDetailPage />,
    roleName: "History_Details",
  },
  // {
  //   path: "/reports/user-performance",
  //   component: <UserPerformanceReportPage />,
  //   roleName: "Reports_User Performance",
  // },
  // {
  //   path: "/reports/daily-activities",
  //   component: <DailyActivitiesReportPage />,
  //   roleName: "Reports_User Performance",
  // },
  // {
  //   path: "/reports/user-leads",
  //   component: <UserLeadsReportPage />,
  //   roleName: "Reports_User Leads",
  // },
  // {
  //   path: "/reports/user-activity",
  //   component: <UserActivitiesReportPage />,
  //   roleName: "Reports_User Activities",
  // },
  // {
  //   path: "/reports/user-won-leads",
  //   component: <UserWonLeadsReportPage />,
  //   roleName: "Reports_User Won Leads",
  // },
  // {
  //   path: "/reports/user-targets",
  //   component: <UserTargetReportPage />,
  //   roleName: "Reports_User Targets",
  // },
  // {
  //   path: "/reports/group-performance",
  //   component: <GroupPerformanceReportPage />,
  //   roleName: "Reports_Group Performance",
  // },
  // {
  //   path: "/reports/profit",
  //   component: <ProfitReportPage />,
  // },
  // {
  //   path: "/reports/SaleReport",
  //   component: <SaleReportPage />,
  //   roleName: "Reports_Sales Report",
  // },
  {
    path: "/reports/sales-pipeline-performance",
    component: <SalesPipelineReportPage />,
    roleName: "CRM-Reports_Sales Performance Report",
  },
  {
    path: "/reports/agent-team-productivity-scorecard",
    component: <AgentTeamProductivityPage />,
    roleName: "CRM-Reports_Agent Team Productivity",
  },
  {
    path: "/reports/target-vs-achievement-scorecard",
    component: <TargetVsAchievementPage />,
    roleName: "CRM-Reports_Target Vs Achievement",
  },
  {
    path: "/reports/deal-loss-reason-analysis",
    component: <DealLossReasonAnalysisPage />,
    roleName: "CRM-Reports_Deal Loss Reason Analysis",
  },
  {
    path: "/reports/pipeline-velocity",
    component: <PipelineVelocityReportPage />,
    roleName: "CRM-Reports_Pipeline Velocity Sales Cycle",
  },
  {
    path: "/reports/lead-transfer-audit",
    component: <LeadTransferAuditReportPage />,
    roleName: "CRM-Reports_Lead Transfer Decay Audit",
  },
  {
    path: "/reports/commission-financial-ledger",
    component: <CommissionAndFinancialLedgerPage />,
    roleName: "CRM-Reports_Commission Financial Ledger",
  },
  {
    path: "/reports/inventory-stock-absorption",
    component: <InventoryStockAbsorptionPage />,
    roleName: "CRM-Reports_Inventory Stock Absorption",
  },
  {
    path: "/reports/commission-dashboard",
    component: <CommissionDashboardPage />,
    roleName: "CRM-Reports_Commission Dashboard",
  },
  {
    path: "/commission-reports/user-commission",
    component: <UserCommissionReportPage />,
    roleName: "Commission Reports_User Commission",
  },
  {
    path: "/commission-reports/CommissionSummary",
    component: <CommissionSummaryPage />,
    roleName: "Commission Reports_Commission Summary",
  },
  {
    path: "/commission-reports/project-commission",
    component: <ProjectWiseCommissionPage />,
    roleName: "Commission Reports_Project Commission",
  },
  {
    path: "/commission-reports/AffiliatePerformance",
    component: <AffiliatePerformancePage />,
    roleName: "Commission Reports_Affiliate Performance",
  },
  {
    path: "/commission-reports/commission-trends",
    component: <MonthlyYearlyCommissionPage />,

    roleName: "Commission Reports_Commission Trends",
  },
  //////
  {
    path: "/commission/generate_commission",
    component: <GenerateCommissionsPage />,
    RoleName: "Commission",
  },
  {
    path: "/commission/pay_commission",
    component: <PayCommissionsPage />,
    RoleName: "Commission",
  },
  {
    path: "/commission/generate_commission/create",
    component: <GenerateCommissionsFormPage />,
    RoleName: "Commission_Create",
  },
  {
    path: "/commission/pay_commission/create",
    component: <PayCommissionFormPage />,
    RoleName: "Commission_Create",
  },
  {
    path: "/report-errors",
    RoleName: "Report_Errors",
    component: <ReportErrorsPage />,
  },
  {
    path: "/settings",
    component: <SettingsPage />,
    roleName: "Settings",
  },
  {
    path: "/settings/groups",
    component: <GroupsPage />,
    roleName: "Groups",
  },
  {
    path: "/create/group",
    component: <CreateGroupPage />,
    roleName: "Groups_Create",
  },
  {
    path: "/settings/support",
    component: <SupportPage />,
    roleName: "Support_View",
  },
  {
    path: "/settings/calender",
    component: <CalendarPage />,
    // roleName: "Support_View",
  },
  {
    path: "/settings/fbpagetoken",
    component: <FbTokenTablePage />,
    roleName: "CRM-Social_Integration_Facebook Page",
  },
  {
    path: "/create/fbpagetoken",
    component: <FbTokenPage />,
    roleName: "CRM-Facebook Page_Create",
  },
  {
    path: "/edit/fbpagetoken",
    component: <FbTokenEditPage />,
    roleName: "CRM-Facebook Page_Edit",
  },
  {
    path: "/settings/whatsappPageToken",
    component: <WATokenTablePage />,
    roleName: "CRM-Social_Integration_WhatsApp Account",
  },
  // {
  //   path: "/create/whatsappPageToken",
  //   component: <WhatsAppToken />,
  //   roleName: "CRM-WhatsApp Account_Create",
  // },
  {
    path: "/settings/business",
    component: <BusinessInfoDetailsPage />,
    roleName: "Other Settings_Business",
  },
  {
    path: "/settings/commission_heads",
    component: <CommissionHeadsPage />,
    roleName: "Commission",
  },
  {
    path: "/settings/commission_templates",
    component: <CommissionTemplatesPage />,
    roleName: "Commission",
  },
  // {
  //   path: "/settings/create/commission_heads",
  //   component: <CreateHeadsPage />,
  //   roleName: "Commission_Create",
  // },
  {
    path: "/settings/create/commission_template",
    component: <CreateTemplatesPage />,
    roleName: "Commission_Create",
  },
  {
    path: "/publicleads",
    component: <PublicLeadsPage />,
    roleName: "Leads_Public Leads",
  },
  // {
  //   path: "/settings/fbpagetoken",
  //   component: (
  //     <UseContainer
  //       activePage={<FbToken />}
  //       disableTitleBar={true}
  //       headerTitle={"Facebook Token"}
  //       buttons={[]}
  //     />
  //   ),
  // },
  {
    path: "/settings/roles",
    component: <RolesPage />,
    roleName: "Roles",
  },
  {
    path: "/create/roles",
    component: <CreateRolePage />,
    roleName: "Roles_Create",
  },
  {
    path: "/settings/users",
    component: <UsersPage />,
    roleName: "Users",
  },
  {
    path: "/create/users",
    component: <CreateUsersPage />,
    roleName: "Users_Create",
  },
  {
    path: "/password/change",
    component: <PasswordChangedFormPage />,
  },
  {
    path: "/settings/users-chats",
    component: <UsersChatsPage />,
    roleName: "Chats",
  },
  {
    path: "/settings/lead",
    component: <LeadPage />,
    roleName: "Lead",
  },
  {
    path: "/settings/piplines",
    component: <PiplinesPage />,
    roleName: "Pipelines",
  },
  // {
  //   path: "/settings/piplines/create",
  //   component: <CreatePiplinesPage />,
  //   roleName: "Pipelines_Create",
  // },
  {
    path: "/settings/sources",
    component: <SourcesPage />,
    roleName: "Sources",
  },
  // {
  //   path: "/settings/sources/create",
  //   component: <CreateSourcesPage />,
  //   roleName: "Sources_Create",
  // },
  {
    path: "/settings/Types",
    component: <TypesPage />,
    roleName: "Types",
  },
  // {
  //   path: "/settings/types/create",
  //   component: <CreateTypesPage />,
  //   roleName: "Types_Create",
  // },
  {
    path: "/settings/activity-types",
    component: <ActivityTypesPage />,
    roleName: "Types",
  },
  {
    path: "/settings/Tags",
    component: <TagsPage />,
    roleName: "Tags",
  },
  // {
  //   path: "/settings/tags/create",
  //   component: <CreateTagsPage />,
  //   roleName: "Tags_Create",
  // },
  {
    path: "/settings/change-request",
    component: <ChangeRequestPage />,
  },
  {
    path: "/settings/change-request/create",
    component: <CreateChangeRequestPage />,
  },
  {
    path: "/settings/descriptions",
    component: <DescriptionsPage />,
    roleName: "Lead_Descriptions",
  },
  // {
  //   path: "/settings/descriptions/create",
  //   component: <DescriptionCreateFormPage />,
  //   roleName: "Descriptions_Create",
  // },
  {
    path: "/chats/facebookpage",
    component: <FacebookPagePage />,
    roleName: "Chats",
  },
  {
    path: "/chats/whatsApp",
    component: <WhatsAppPage />,
    roleName: "Chats",
  },
  {
    path: "/settings/inventory/project",
    component: <ProjectPage />,
    roleName: "Inventory Settings_Projects",
  },
  {
    path: "/settings/inventory/project/create",
    component: <CreateProjectPage />,
    roleName: "Projects_Create",
  },
  {
    path: "/inventory/overview",
    component: <Navigate to="/inventory/insights/overview" replace />,
    roleName: "Inventory_Unit",
  },
  {
    path: "/inventory/insights/overview",
    component: <InventoryOverviewPage />,
    roleName: "Inventory_Unit",
  },
  {
    path: "/inventory/insights/aging",
    component: <InventoryOverviewPage />,
    roleName: "Inventory_Unit",
  },
  {
    path: "/inventory/insights/performance",
    component: <InventoryOverviewPage />,
    roleName: "Inventory_Unit",
  },
  {
    path: "/inventory/unit",
    component: <UnitPage />,
    roleName: "Inventory_Unit",
  },
  {
    path: "/inventory/booked-unit",
    component: <BookedUnitsPage />,
    roleName: "Inventory_Booked Unit",
  },
  {
    path: "/inventory/unit/create",
    component: <CreateUnitPage />,
    roleName: "Unit_Create",
  },
  {
    path: "/settings/inventory/section",
    component: <SectionPage />,
    roleName: "Inventory Settings_Sections",
  },
  {
    path: "/settings/inventory/section/create",
    component: <CreateSectionPage />,
    roleName: "Sections_Create",
  },
  {
    path: "/settings/inventory/category",
    component: <CategoryPage />,
    roleName: "Inventory Settings_Category",
  },
  // {
  //   path: "/settings/inventory/category/create",
  //   component: <CategoryCreateUpdateScreenPage />,
  //   roleName: "Category_Create",
  // },
  {
    path: "/target",
    component: <TargetPage />,
    roleName: "Target_Targets",
  },
  {
    path: "/target/create",
    component: <CreateTargetPage />,
    roleName: "Targets_Create",
  },
  {
    path: "/assigned-target",
    component: <AssignedTargetsPage />,
    roleName: "Target_Assign Targets",
  },
  {
    path: "/settings/message-automation",
    component: <MessageAutomationPage />,
    roleName: "CRM-Social_Integration_Message Automation",
  },
];

export const SuperAdminRoutes = [
  {
    path: "/",
    component: <LoginContent />,
  },
  {
    path: "/profile",
    component: <UpdateProfilePage />,
    roleName: [
      "CRM-Profile",
    ],
  },
  {
    path: "/profile/business",
    component: <UpdateProfilePage defaultTab="business" />,
    roleName: [
      "CRM-Profile_Business",
    ],
  },
  {
    path: "/settings/profile/business",
    component: <UpdateProfilePage defaultTab="business" />,
    roleName: [
      "CRM-Profile_Business",
    ],
  },
  {
    path: "/forgotpassword",
    component: <ForgotPassword />,
  },
  {
    path: "/reset/password",
    component: <ResetPassword />,
  },

  {
    path: "/business",
    component: <BusinessTablePage />,
  },

  {
    path: "/business/create",
    component: <EditBusinessInfoPage />,
  },
  {
    path: "/business/info-edit",
    component: (
      // <UseContainer
      //   activePage={<EditBusinessInfo />}
      //   breadCrumb={"Business"}
      //   headerTitle={"Business"}
      //   disableTitleBar={true}
      //   buttons={[]}
      // />
      <EditBusinessInfoPage />
    ),
  },
  // {
  //   path: "/business/plan-edit",
  //   component: (
  //     <UseContainer activePage={<EditBusinessPlan />} breadCrumb={"Business"} headerTitle={"Business"} buttons={[]} />
  //   ),
  // },
  {
    path: "/business/detail",
    component: <BusinessInfoDetailsSuperAdminPage />,
  },

  {
    path: "/subscription",
    component: <SubscriptionTablePage />,
  },
  {
    path: "/subscription/create",
    component: <SubscriptionFormPage />,
  },
  {
    path: "/screens",
    component: <ScreensPage />,
  },
  {
    path: "/users",
    component: <UserOverviewPage />,
  },
  {
    path: "/payments",
    component: <TransactionsTablePage />,
  },
  {
    path: "/payment/create",
    component: <TransactionFormPage />,
  },
  {
    path: "/configsetting",
    component: <ConfigSettingTablePage />,
  },
  {
    path: "/configsetting/create",
    component: <ConfigSettingFormPage />,
  },
  {
    path: "/module",
    component: <ModuleTablePage />,
  },
  {
    path: "/module/create",
    component: <ModuleFormPage />,
  },
  {
    path: "/expired-business-plan",
    component: <ExpiredBusinessPlanPage />,
  },
];
